import { Box, Flex, Text } from "@chakra-ui/layout";
import useDashboardReservas from "features/reservas/hooks/useDashboardReservas";
import useReservas from "features/reservas/hooks/useReservas";
import { ListagemReservaResponse } from "features/reservas/typings";
import { useEffect, useState } from "react";
import DateRangePicker from "components/Input/DateRangePicker";
import useFiltroReservas from "../../hooks/useFiltroReservas";
import CalendarioReserva from "../CalendarioReserva";
import DashboardReservas from "../DashboardReservas";
import ModalReserva from "../ModalReserva";
import ReservasTable from "../ReservasTable";
import ModalFiltros from "../ModalFiltros";
import ModalDetalheReserva from "components/ModalDetalheReserva";
import { useCurrentTenant } from "features/auth/tenant.store";
import { getDefaultValuesForMessageModal } from "../../util/helper";
import { useMensagemModal } from "ui/components/DrawerNovaMensagem/MensagemModalContext";
import useCancelarReserva from "core/features/reservas/hooks/useCancelarReserva";
import ModalRejeitarMotivo from "components/ModalRejeitarMotivo/ModalRejeitarMotivo";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import useConfirmarReserva from "core/features/reservas/hooks/useConfirmarReserva";
import PageHeader from "components/Page/PageHeader";
import ModalListaConvidados from "ui/components/ModalPortariaPessoas";
import moment from "moment";
import { StatusReservaEnum } from "core/features/reservas/typings";
import ModalHistoricoReserva from "./../ModalHistoricoReserva/index";
import useHasPermission from "core/features/permissions/hooks/useHasPermission";
import { PermissaoEnum } from "core/resources/enums/permissao";
import { useRegrasTenant } from "core/features/tenants/tenants.context";
import { useLocation } from "react-router";
import ModalInicioSubtenantsView from "components/ModalInicioSubtenantsView/index";

function ListaReservas() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const searchParamsReservaId = params.get("reservaId") as string;

  const { tenant } = useCurrentTenant();
  const { useSubtenantsViews } = useRegrasTenant();

  const hasPermissionCriar = useHasPermission(
    PermissaoEnum.Backoffice.Administrativo.Reserva.Criar
  );

  const { openWithDefaultValues } = useMensagemModal();

  const [activeListQuery, setActiveListQuery] = useState<boolean>(
    !useSubtenantsViews
  );

  const [isOpenModalInicioSubtenantsView, setIsOpenModalInicioSubtenantsView] =
    useState(useSubtenantsViews);

  const [view, setView] = useState<"CALENDARIO" | "LISTA">("CALENDARIO");
  const [selectedReserva, setSelectedReserva] = useState<
    Partial<ListagemReservaResponse> | undefined
  >();
  const [editReservaId, setEditReservaId] = useState<string | undefined>();
  const [cancelReservaId, setCancelReservaId] = useState<string | undefined>();
  const [selectedReservaListaConvidados, setSelectedReservaListaConvidados] =
    useState<ListagemReservaResponse | undefined>();

  const { filtro, onChangeFiltro, onResetFiltro } = useFiltroReservas();
  const {
    data: reservas,
    isLoading,
    refetch,
    isFetching,
  } = useReservas(
    {
      ...filtro,
      limit: view === "CALENDARIO" ? 99999 : filtro.limit,
      id: searchParamsReservaId,
    },
    activeListQuery
  );

  const { mutate: cancelarReserva, isLoading: isLoadingCancelar } =
    useCancelarReserva();
  const { mutate: confirmarReserva, isLoading: isLoadingConfirmarReserva } =
    useConfirmarReserva();

  const {
    data: dashboard,
    isLoading: isLoadingDashboard,
    refetch: refetchDashboard,
  } = useDashboardReservas({
    filtro,
  });

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenModalFiltro, setIsOpenModalFiltro] = useState(false);
  const [isOpenModalDetalhe, setIsOpenModalDetalhe] = useState(false);
  const [historicoReservaId, setHistoricoReservaId] = useState<
    string | undefined
  >();

  const _isLoading = isLoading || isFetching;

  useEffect(() => {
    if (editReservaId) {
      setIsOpenModal(true);
    }
  }, [editReservaId]);

  useEffect(() => {
    if (!isOpenModal) {
      setEditReservaId(undefined);
    }
  }, [isOpenModal]);

  useEffect(() => {
    if (searchParamsReservaId && reservas?.items) {
      const reserva = reservas?.items?.find(
        (reserva) => reserva.id === searchParamsReservaId
      );

      setSelectedReserva(reserva ?? { id: searchParamsReservaId });
      setIsOpenModalDetalhe(true);
    }
  }, [reservas?.items, searchParamsReservaId]);

  const onSearch = (search: string | undefined) => onChangeFiltro({ search });

  useEffect(() => {
    onChangeFiltro({ page: 1 });
  }, [onChangeFiltro, view]);

  const numFiltros =
    (filtro.dataInicio || filtro.dataFim ? 1 : 0) +
    (filtro.unidadeId ? 1 : 0) +
    (filtro.pessoaId ? 1 : 0) +
    (filtro.status ? 1 : 0) +
    (filtro.areaComumId ? 1 : 0) +
    (filtro.tenantsIds?.length ? 1 : 0);

  const shouldShowConfirmButtonOnGuestListModal =
    selectedReservaListaConvidados &&
    moment(selectedReservaListaConvidados.data).isSame(moment(), "day") &&
    selectedReservaListaConvidados.status.id === StatusReservaEnum.Confirmada;

  return (
    <>
      <PageHeader
        title="Reserva de espaços"
        mb="24px"
        titleButton={
          hasPermissionCriar && !useSubtenantsViews ? "Nova reserva" : undefined
        }
        onClick={() => setIsOpenModal(true)}
        extraButtonTitle="Filtros avançados"
        extraButtonOnClick={() => setIsOpenModalFiltro(true)}
        badge
        badgeValueExtraButton={numFiltros}
        midComponent={
          <Flex>
            <Box w="270px">
              <DateRangePicker
                allowEmptyDates={{
                  dataInicio: true,
                  dataFim: false,
                }}
                onChange={(dataInicio, dataFim) => {
                  onChangeFiltro({
                    dataInicio,
                    dataFim,
                  });
                }}
                value={{
                  dataInicio: filtro.dataInicio!,
                  dataFim: filtro.dataFim!,
                }}
                disabled={view === "CALENDARIO"}
              />
            </Box>
          </Flex>
        }
      />

      <Box w="80%">
        <DashboardReservas
          totalReservas={dashboard?.total}
          reservasHoje={dashboard?.hoje}
          semAprovacao={dashboard?.semAprovacao}
          loading={isLoadingDashboard}
          filtro={filtro}
          onResetFiltro={onResetFiltro}
        />
      </Box>

      {!activeListQuery ? (
        <Box mt="32px">
          <Text textAlign="center" fontSize="16px" fontWeight="medium">
            Utilize os filtros avançados para carregar a lista de reservas
          </Text>
        </Box>
      ) : null}

      <Box mt="32px">
        {view === "LISTA" ? (
          <ReservasTable
            data={reservas}
            onPaginate={(page, limit) => onChangeFiltro({ page, limit })}
            isLoading={_isLoading}
            searchValue={filtro.search || ""}
            onRowClick={(record) => {
              setSelectedReserva(record);
              setIsOpenModalDetalhe(true);
            }}
            onShowGuestList={setSelectedReservaListaConvidados}
            onSearch={onSearch}
            onChangeView={() => setView("CALENDARIO")}
            onEdit={setEditReservaId}
            onCancel={setCancelReservaId}
            refetch={refetch}
            onShowHistorico={setHistoricoReservaId}
          />
        ) : (
          <CalendarioReserva
            onChangeDate={(start, end) => {
              onChangeFiltro({
                dataInicio: start.replace(/[/]/g, "-"),
                dataFim: end.replace(/[/]/g, "-"),
              });
            }}
            loading={isLoading}
            reservas={reservas?.items}
            onClick={(v) => {
              setSelectedReserva(v);
              setIsOpenModalDetalhe(true);
            }}
            search={filtro.search || ""}
            onSearch={onSearch}
            onChangeView={() => setView("LISTA")}
          />
        )}
      </Box>

      {isOpenModal ? (
        <ModalReserva
          tenantId={tenant.id}
          isOpen={isOpenModal}
          onClose={() => setIsOpenModal(false)}
          onSave={() => {
            refetch();
            setIsOpenModal(false);
            refetchDashboard();
          }}
          reservaId={editReservaId}
        />
      ) : null}

      {isOpenModalFiltro ? (
        <ModalFiltros
          tenantId={tenant.id}
          isOpen={isOpenModalFiltro}
          onClose={() => setIsOpenModalFiltro(false)}
          onSave={() => {
            setActiveListQuery(true);
            refetch();
            setIsOpenModalFiltro(false);
            refetchDashboard();
          }}
          filtro={filtro}
          onChangeFiltro={onChangeFiltro}
          onReset={() => {
            onResetFiltro();
            setActiveListQuery(false);
          }}
        />
      ) : null}

      {isOpenModalDetalhe ? (
        <ModalDetalheReserva
          isOpen={isOpenModalDetalhe}
          onCancel={setCancelReservaId}
          onConfirm={(id) => {
            confirmarReserva(id, {
              onSuccess: () => {
                refetch?.();
                setIsOpenModalDetalhe(false);
              },
            });
          }}
          onClose={() => setIsOpenModalDetalhe(false)}
          isLoadingCancelar={isLoadingCancelar}
          isLoadingConfirmar={isLoadingConfirmarReserva}
          reservaId={selectedReserva ? selectedReserva.id! : ""}
          onSendMessage={
            selectedReserva
              ? () =>
                  openWithDefaultValues(
                    getDefaultValuesForMessageModal(selectedReserva!)
                  )
              : undefined
          }
        />
      ) : null}

      {selectedReservaListaConvidados ? (
        <ModalListaConvidados
          onClose={() => setSelectedReservaListaConvidados(undefined)}
          eventoId={selectedReservaListaConvidados.eventoId}
          portariaId={selectedReservaListaConvidados.id}
          visible={!!selectedReservaListaConvidados}
          showConfirmButton={shouldShowConfirmButtonOnGuestListModal}
        />
      ) : null}

      {historicoReservaId ? (
        <ModalHistoricoReserva
          isOpenModal={!!historicoReservaId}
          onClose={() => {
            setHistoricoReservaId(undefined);
          }}
          reservaId={historicoReservaId}
        />
      ) : null}

      {useSubtenantsViews && isOpenModalInicioSubtenantsView ? (
        <ModalInicioSubtenantsView
          isOpen={isOpenModalInicioSubtenantsView}
          onClose={() => setIsOpenModalInicioSubtenantsView(false)}
          onOpenFiltros={() => {
            setIsOpenModalFiltro(true);
            setIsOpenModalInicioSubtenantsView(false);
          }}
          onVerTudo={() => {
            setActiveListQuery(true);
            setIsOpenModalInicioSubtenantsView(false);
          }}
        />
      ) : null}

      <ModalRejeitarMotivo
        isLoadingSave={isLoadingCancelar}
        visible={!!cancelReservaId}
        onClose={() => setCancelReservaId(undefined)}
        primaryButtonText="Cancelar reserva"
        secondaryButtonText="Fechar"
        onSubmit={(motivo) => {
          cancelarReserva(
            {
              id: cancelReservaId!,
              motivo,
            },
            {
              onError: (e) => showErrorAxios(e),
              onSuccess: () =>
                showSuccess("Reserva cancelada com sucesso").then(() => {
                  setCancelReservaId(undefined);
                  refetch();
                  setIsOpenModalDetalhe(false);
                }),
            }
          );
        }}
      />
    </>
  );
}

export default ListaReservas;
